import { NgModule } from '@angular/core';
import { HeaderNotAuthenticatedComponent } from '@components/headerNotAuthenticated/header-not-authenticated.component';
import { CommonModule } from '@angular/common';
import { SharedPipeModule } from '@app/shared/pipes/shared.pipe.module';

import { VerticalLinkBoxComponent } from '@components/headerNotAuthenticated/verticalLinkBox/verticalLinkBox';
import { MainMaterialModule } from '@app/shared/mainComponent/mainMaterial.module';
import { RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@NgModule({
  imports: [
    MainMaterialModule,
    CommonModule,
    MatIconModule,
    RouterModule,
    SharedPipeModule,
    MatBadgeModule,
    LazyLoadImageModule,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
  ],
  declarations: [HeaderNotAuthenticatedComponent, VerticalLinkBoxComponent],
  exports: [HeaderNotAuthenticatedComponent],
})
export class HeaderNotAuthenticatedModule {}
